import { render } from "./TempiDiAttesa.vue?vue&type=template&id=7ab5020b&scoped=true"
import script from "./TempiDiAttesa.vue?vue&type=script&lang=js"
export * from "./TempiDiAttesa.vue?vue&type=script&lang=js"

import "./TempiDiAttesa.vue?vue&type=style&index=0&id=7ab5020b&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab5020b"]])

export default __exports__